export const myMinxin={
  data(){
      return {
        fontsize: {  // 字体颜色
            color: "#6E6E6E"
        },
        backcolor: { // 背景颜色
            background: "#242526"
        },
       
      }
  }
}